module.exports = __webpack_public_path__ + "static/media/facebook.c1a42918.svg";